// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2NTpe","emails":"CreateEditClinics_emails__29Dpp","emailTagLabel":"CreateEditClinics_emailTagLabel__2DETM"};